import { ConfigBase } from '@cbsi-cbscom/auth-suite-config';
import {
    AuthSuiteSdkSetupService,
    AuthSuiteAccessService,
    AuthSuiteProvidersService,
    AuthSuiteAuthorizationService,
    AuthSuiteMessagingService,
    loginEvent,
    AuthSuiteLocalDataStorageService,
    AuthSuiteAccessTokenService,
} from './AuthSuiteServices';

export default class AuthSuiteSdkProvider {
    constructor(authSuiteConfiguration) {
        if (authSuiteConfiguration.env === 'prod') {
            ConfigBase.setConfig(require('@cbsi-cbscom/auth-suite-config-prod').envConfig);
        } else {
            ConfigBase.setConfig(require('@cbsi-cbscom/auth-suite-config-qa').envConfig);
        }

        this.accountSdkSetup = new AuthSuiteSdkSetupService();
        this.authSuiteSetup(authSuiteConfiguration);
    }

    authSuiteSetup({ clientId, countryCode }) {
        if (clientId && countryCode) {
            this.accountSdkSetup.setupAuthSuiteRequestData({
                clientId,
                countryCode,
            });
        } else {
            console.error(
                'ClientId:[%s] or CountryCode:[%s] is invalid, can not initialize AuthSuite.',
                clientId,
                countryCode,
            );
        }
    }

    getAuthSuiteServices() {
        return {
            accessService: new AuthSuiteAccessService(),
            providersService: new AuthSuiteProvidersService(),
            authorizationService: new AuthSuiteAuthorizationService(),
            messagingService: new AuthSuiteMessagingService(),
            loginEvent,
            localStorageService: new AuthSuiteLocalDataStorageService(),
            accessTokenService: new AuthSuiteAccessTokenService(),
        };
    }
}
